import { useQuery } from "@tanstack/react-query";
import { fetchActiveStaff } from "@/lib/services/staffService";

/**
 * React Query hook for the company's full active-staff roster.
 *
 * Backed by /company/staff/active, which is not schedule-derived — so masters
 * who have no shifts in the displayed week (or none for months) are listed too.
 * Consumers: the header staff selector, the waitlist add-entry form, and the
 * appointment modal's master selector.
 */
export function useAllStaff(enabled: boolean = true) {
  return useQuery({
    queryKey: ["allStaff"],
    queryFn: fetchActiveStaff,
    staleTime: 10 * 60 * 1000, // 10 minutes
    enabled,
  });
}
